import { gql } from 'apollo-angular';

export const RemoveFlowDocument = gql`
  mutation removeFlow($flowId: Int!) {
    removeFlow(flowId: $flowId)
  }
`;
